import React from "react";
import { Linking, StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";
import { getDayofWeek } from "../../../services/Config";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import { formatPhone, formatTellPhone, toTitleCase } from "../../../helpers/util"

export default function OpeningHours({ unityData, setStatePopUp }) {
  
  let openingHours = []
  let itemConcat = {firstDay: null, lastDay: null, hours: null}
  unityData.openingHours.map((dayOfWeekHours, index) => {
    let item = {days: getDayofWeek(index), hours: dayOfWeekHours}
    if(item.hours == unityData.openingHours[index + 1] || item.hours == unityData.openingHours[index - 1]){
      if(!itemConcat.firstDay){
        itemConcat.firstDay = getDayofWeek(index)
      }
      itemConcat.lastDay = getDayofWeek(index)
      itemConcat.hours = dayOfWeekHours
    }   
    else {
      openingHours.push(item)
    }
  })

  openingHours.push({days : `${itemConcat.firstDay} a ${itemConcat.lastDay}` , hours: itemConcat.hours})

  openingHours.reverse()

  return (
    <View style={styles.viewOpeningHours}>
      <View style={styles.viewOpeningHoursTitle}>
        <Icon name="time-outline" size={24} />
        <Text style={styles.titleOpeningHours}>
          {"Horario de funcionamento"}
        </Text>
      </View>
      <View style={styles.viewOpeningHoursData}>
        <View>
          {openingHours.map((dayOfWeekHours, index) => {
            return (
              <Text style={styles.textOpeningHours} key={index}>
                {dayOfWeekHours.days}
              </Text>
            );
          })}
        </View>
        <View>
          {openingHours.map((dayOfWeekHours, index) => {
            return (
              <Text
                style={[
                  styles.textOpeningHoursData,
                  { color: dayOfWeekHours.hours == "Fechado" ? Colors.ALERT : Colors.BLACK },
                ]}
                key={index + "Data"}
              >
                {dayOfWeekHours.hours}
              </Text>
            );
          })}
        </View>
      </View>
      <View style={styles.viewOpeningHoursTitle}>
        <Icon name="location-outline" size={24} />
        <Text
          style={styles.dataOpeningHours}
          onPress={() => setStatePopUp(true)}
        >
          {toTitleCase(unityData.address)}
        </Text>
      </View>
      <View style={styles.viewOpeningHoursTitle}>
        <Icon name="call-outline" size={24} />
        <Text
          style={styles.dataOpeningHours}
          onPress={() => Linking.openURL(`tel:${unityData.telephone}`)}
        >
          {unityData.telephone.toString().length == 11 ? formatPhone(unityData.telephone) : formatTellPhone(unityData.telephone)}
        </Text>
      </View>
      <View style={styles.viewOpeningHoursTitle}>
        <Icon name="mail-outline" size={24} />
        <Text
          style={styles.dataOpeningHours}
          onPress={() => Linking.openURL(`mailto:${unityData.email}`)}
        >
          {unityData.email}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewOpeningHours: {},
  viewOpeningHoursData: {
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  titleOpeningHours: {
    fontWeight: "bold",
    fontSize: Fonts.FONT_SIZE_16,
    marginLeft: 4,
  },
  viewOpeningHoursTitle: {
    flexDirection: "row",
    alignItems: "center",
  },
  textOpeningHours: {
    paddingHorizontal: 4,
    fontWeight: "500",
    marginLeft: 16,
  },
  textOpeningHoursData: {
    paddingHorizontal: 4,
  },
  dataOpeningHours: {
    padding: 4,
    fontSize: Fonts.FONT_SIZE_14,
    color: Colors.HYPERLINK,
  },
});
